import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SelectField } from "@/lib/crm";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const useDebounced = (url, params, map, deps) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get(url, { params }).then((r) => setItems(map(r.data))).catch(() => setItems([])), 250);
    return () => clearTimeout(t);
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  return items;
};

const NewIntervention = ({ value, onChange, types, techs }) => {
  const [q, setQ] = useState("");
  const companies = useDebounced("/interventions/companies", { q, limit: 15 }, (d) => d.items, [q]);
  return (
    <div className="space-y-3" data-testid="calendar-event-new-intervention">
      <Input placeholder="Cerca cliente" value={q} onChange={(e) => setQ(e.target.value)} maxLength={100} data-testid="calendar-event-new-itv-company-search" />
      <div className="grid grid-cols-2 gap-3">
        <SelectField label="Cliente" value={value.company_id} onChange={(v) => onChange({ ...value, company_id: v })} testId="calendar-event-new-itv-company"
          options={companies.map((c) => ({ id: c.id, name: c.city ? `${c.name} (${c.city})` : c.name }))} />
        <SelectField label="Tipo" value={value.type} onChange={(v) => onChange({ ...value, type: v })} options={types} testId="calendar-event-new-itv-type" />
      </div>
      {techs && <SelectField label="Tecnico (obbligatorio)" value={value.lead_technician_id} onChange={(v) => onChange({ ...value, lead_technician_id: v })}
        options={techs} placeholder="Seleziona il tecnico" testId="calendar-event-new-itv-technician" />}
      <p className="text-xs text-slate-500">Il titolo dell'intervento sarà quello dell'appuntamento.</p>
    </div>
  );
};

export const InterventionLink = ({ value, assignee, onChange, onAssignee, onPicked, creating, onCreating }) => {
  const { me, can } = useAuth();
  const user = me?.user;
  const canAssign = can("interventions:assign");
  const canCreate = can("interventions:create");
  const [q, setQ] = useState("");
  const [meta, setMeta] = useState({ types: [], technicians: [] });
  const items = useDebounced("/interventions", { open: true, q: q || undefined, limit: 20 },
    (d) => d.items.filter((i) => !["in_corso", "completato", "annullato"].includes(i.status)), [q]);
  useEffect(() => { api.get("/interventions/meta").then((r) => setMeta(r.data)).catch(() => {}); }, []);
  const sel = items.find((i) => i.id === value);
  const pick = (id) => { onChange(id); onPicked(items.find((i) => i.id === id)); };
  const people = [{ id: user?.id, name: "Me" }, ...(canAssign ? meta.technicians.filter((t) => t.id !== user?.id) : [])];
  const unassigned = !creating && value && sel && !sel.lead_technician_id;

  return (
    <div className="space-y-3 rounded-control border border-line p-3" data-testid="calendar-event-intervention-box">
      {creating ? <NewIntervention value={creating} onChange={onCreating} types={meta.types} techs={canAssign ? meta.technicians : null} /> : <>
        <Input placeholder="Cerca intervento (numero, titolo, cliente)" value={q} onChange={(e) => setQ(e.target.value)} maxLength={100} data-testid="calendar-event-intervention-search" />
        <SelectField label="Intervento collegato (facoltativo)" value={value} onChange={pick} allowNone="Nessun intervento" testId="calendar-event-intervention"
          options={items.map((i) => ({ id: i.id, name: `${i.number} · ${i.title}${i.company_name ? ` — ${i.company_name}` : ""}` }))} />
      </>}
      {canCreate && !value && (
        <Button type="button" size="sm" variant="ghost" className="h-7 px-2 text-xs" data-testid="calendar-event-new-itv-toggle"
          onClick={() => onCreating(creating ? null : { company_id: "", type: "assistenza", lead_technician_id: "" })}>
          {creating ? "Collega un intervento esistente" : "+ Crea nuovo intervento"}
        </Button>
      )}
      {value && sel?.lead_technician_id && (
        <p className="text-xs text-slate-500" data-testid="calendar-event-assignee-inherited">Assegnatario: <b>{sel.lead_technician_name}</b> (tecnico dell'intervento)</p>
      )}
      {unassigned && <SelectField label="Assegnatario" value={assignee || user?.id} onChange={onAssignee} options={people} testId="calendar-event-assignee" />}
      {(value || creating) && <p className="text-xs text-slate-500">Verrà creata (o aggiornata) l'attività CRM collegata all'intervento.</p>}
    </div>
  );
};
